// removed by extract-text-webpack-plugin
module.exports = {"modal":"modal___LxKOW","overlay":"overlay___1tzvL","box":"box___18bt0","big":"big___2vjHP","negative":"negative___3LoFm","form":"form___R1-nS","element":"element___2YYwf","footer":"footer___2NJto","noFixed":"noFixed___1xnWv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/index.scss
// module id = 100
// module chunks = 0